import React from 'react'
import { groupLabel } from '../../service'
import PropTypes from 'prop-types'
import {
  Autocomplete,
  Box,
  Chip,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'

GroupOptions.propTypes = {
  groups: PropTypes.array,
  selectedGroups: PropTypes.array,
  onGroupChange: PropTypes.func,
  disabled: PropTypes.bool
}

const friendlyName = groupLabel

export default function GroupOptions ({
  groups = [],
  selectedGroups = [],
  onGroupChange,
  disabled = false
}) {
  // Existing shares stay visible even when the editor is not a member of that group.
  const available = Array.from(new Set([...groups, ...selectedGroups]))
  const selected = available.filter(group => selectedGroups.includes(group))

  return (
    <Stack spacing={1}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={available}
        value={selected}
        disabled={disabled}
        onChange={(_event, value) => {
          if (onGroupChange) onGroupChange(value)
        }}
        getOptionLabel={friendlyName}
        isOptionEqualToValue={(option, value) => option === value}
        renderTags={(value, getTagProps) => value.map((group, index) => (
          <Chip
            {...getTagProps({ index })}
            key={group}
            label={friendlyName(group)}
            size="small"
            icon={<GroupsOutlinedIcon />}
          />
        ))}
        renderInput={params => (
          <TextField
            {...params}
            size="small"
            label="Share with groups"
            placeholder={selected.length ? '' : 'Search groups'}
            helperText={selected.length
              ? `Shared with ${selected.length} group${selected.length === 1 ? '' : 's'}`
              : 'Private to your account'}
          />
        )}
      />

      {!selected.length
        ? <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
              color: 'text.secondary'
            }}
          >
            <LockOutlinedIcon sx={{ fontSize: 16 }} />
            <Typography variant="caption">
              Private. Only you can access this item.
            </Typography>
          </Box>
        : null}
    </Stack>
  )
}
